import { announce } from 'theme';

/**
 * Makes the minus and plus buttons of snippets/quantity-input.liquid work. The number field already knows its minimum, maximum
 * and step, so the buttons only ask it to move, and what the form submits is always what the field shows.
 */
if (!customElements.get('quantity-input')) {
  customElements.define(
    'quantity-input',
    class extends HTMLElement {
      #onClick = (event) => {
        const button = event.target.closest('button[data-step]');
        if (!button) return;

        const field = this.querySelector('input');
        const before = field.value;
        if (button.dataset.step === 'up') {
          field.stepUp();
        } else {
          field.stepDown();
        }

        if (field.value !== before) {
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
        announce(field.value);
      };

      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }
    },
  );
}
